<template>
  <div class="md-layout md-alignment-center-center flex-1">
    <div class="md-layout-item md-size-50 md-xsmall-size-100 md-small-size-100 md-medium-size-90 md-large-size-75">
      <md-card>
        <md-card-header data-background-color="secondary">
          <h4 class="title">Registration</h4>
          <p class="category">
            Register for your SML Buyers Hub account and
            purchase/renew your Market Access Pass.
          </p>
        </md-card-header>
        <md-card-content>
          <registration-form />
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import RegistrationForm from "../Forms/RegistrationForm.vue";
export default {
  components: {
    RegistrationForm
  },
  mounted() {
    if (this.$route.query.t && this.$route.query.d) {
      this.$toast.open({
        message:
          "No account was found with the given email or mobile; please register.",
        type: "warning",
        position: "top",
        duration: 6000
      });
    }
  }
};
</script>
